import logger from './logger';

export class HttpResponseError extends Error {
  response: Response;

  body?: any;

  constructor(response: Response, message?: string) {
    super(message || 'HTTP response error');
    this.response = response;
    this.name = 'HttpResponseError';
  }

  async loadBody() {
    try {
      this.body = await this.response.json();
    } catch (err) {
      logger.error(`Error reading the response body:' ${err}`);
    }
  }
}
